// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-container[data-v-c4901aa2] {\n  margin-bottom: 15px;\n}\nlabel[data-v-c4901aa2] {\n  display: block;\n}\n.inValida[data-v-c4901aa2] {\n  border: 1px solid #a94442;\n}\n.mensagemDeErro[data-v-c4901aa2] {\n  margin: 0 0 10px 0;\n  color: #a94442;\n  font-size: 12px;\n}\n.labelObrigatorio[data-v-c4901aa2] {\n  color: #a94442;\n}\n.cursor-not-allowed[data-v-c4901aa2] {\n  cursor: not-allowed !important;\n}\n.help-tip[data-v-c4901aa2] {\n  vertical-align: text-bottom;\n}", ""]);
// Exports
module.exports = exports;
